export default __webpack_public_path__ + "static/media/twitterIcon.f70cc3aa.svg";